function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 .1c3.7 0 6.9 2 8.7 5L13.6 8c-.7-1.2-2-2.1-3.6-2.1A4 4 0 0 0 5.9 10a4.1 4.1 0 0 0 7.7 2l5.1 2.9c-1.7 3-5 5-8.7 5A9.9 9.9 0 1 1 10 .1zM63 1h6v18h-6zM26.3 1v6.4h6.4V1H39v18h-6.3v-6.5h-6.4V19H20V1zM54.1 1h-6.2L40 19h6.2l.6-1.5H55l.6 1.5H62L54.1 1zm-5.4 12.3L51 8.1l2.3 5.2h-4.6z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F02937",
  d: "M111.9.8v5.3h-9.4v2.3h8.7v4.9h-8.7v6h-6.3V.8zM84 .8h-7.2v18.6h7c7.6 0 11.4-3.9 11.4-9.4v-.1C95.1 4.4 91.4.8 84 .8zm4.8 9.3c0 2.7-1.8 3.8-4.7 3.8h-1V6.2h1c2.9 0 4.7 1.1 4.7 3.9z"
});

var SvgChai = function SvgChai(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 112,
    height: 20,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChai, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CHAI.09f54586.svg";
export { ForwardRef as ReactComponent };